import { useDependedFieldsValueControl } from '@sravni/cosago-react-library/lib/hooks';

import type { TPledgeEstateFields } from 'entities/pledgeEstateForm';

export function usePledgeEstateFieldsControl() {
  useDependedFieldsValueControl<TPledgeEstateFields>({
    fieldName: 'isOnlyOwner',
    fieldsToResetOnChangeValue: [
      {
        fieldName: 'otherOwnerFullName',
        resetTo: null,
      },
      {
        fieldName: 'otherOwnerPhone',
        resetTo: null,
      },
      {
        fieldName: 'otherOwnerMaritalStatus',
        resetTo: null,
      },
      {
        fieldName: 'relationship',
        resetTo: null,
      },
    ],
  });
}
